import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDirectorChair: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"director-chair, chair"} maskId="square-filled-radius-0-stroke-1-IconDirectorChair"><path fillRule="evenodd" clipRule="evenodd" d="M4 2V11H2V12H4.34861L11.0986 16.5L3.80662 21.3613L4.36132 22.1934L12 17.1009L19.6387 22.1934L20.1934 21.3613L12.9014 16.5L19.6514 12H22V11H20V2H4ZM12 15.8991L6.15139 12H17.8486L12 15.8991Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconDirectorChair;
